import { ApiResourceBaseClass as i } from "./baseApiCalls.js";
const e = "custom_fields/section";
class c extends i {
  /**
   * Gets custom fields sections.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/custom_fields/section`
   *
   * @param {number} [org_id] - Optional organization ID
   * @returns {Promise<CustomFieldsSectionsGetData>} A promise resolving to the sections data
   */
  getCustomFieldsSections = async (t) => {
    const s = t ? `${e}?org_id=${t}` : e, { data: a } = await this.get(s);
    return a;
  };
  /**
   * Creates a new custom fields section.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/custom_fields/section`
   *
   * @param {CustomFieldsSectionCreationPayload} sectionData - The data for creating the section
   * @returns {Promise<CustomFieldsSectionsCreateData>} A promise resolving to the created section data
   */
  createCustomFieldsSection = async (t) => {
    const { data: s } = await this.post(
      e,
      t
    );
    return s;
  };
  /**
   * Edits an existing custom fields section.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/custom_fields/section/:sectionId`
   *
   * @param {number} sectionId - The ID of the section to edit
   * @param {CustomFieldsSectionCreationPayload} sectionData - The data for updating the section
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response
   */
  editCustomFieldSection = async (t, s) => {
    const { data: a } = await this.put(
      `${e}/${t}`,
      s
    );
    return a;
  };
  /**
   * Deletes a custom fields section.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/custom_fields/section/:sectionId`
   *
   * @param {number} sectionId - The ID of the section to delete
   * @returns {Promise<SuccessResponse>} A promise resolving to the success response
   */
  deleteCustomFieldSection = async (t) => {
    const { data: s } = await this.delete(
      `${e}/${t}`
    );
    return s;
  };
}
export {
  e as CUSTOM_FIELDS_SECTIONS_RESOURCE_URI,
  c as CustomFieldsSections
};
